import { gql } from '@apollo/client'
// graphql
import { CHART_FIELDS } from './queries'

// The whole chart comes back so every tile showing it updates from the Apollo cache
export const CHART_CREATE_MUTATION = gql`
  mutation CHART_CREATE_MUTATION($input: ChartCreateInput!) {
    chartCreate(input: $input) {
      ${CHART_FIELDS}
    }
  }
`

export const CHART_UPDATE_MUTATION = gql`
  mutation CHART_UPDATE_MUTATION($input: ChartUpdateInput!) {
    chartUpdate(input: $input) {
      ${CHART_FIELDS}
    }
  }
`

// Recomputes the viewer's snapshots; each one ends with a CHART_DATA_UPDATED notification
export const CHARTS_REFRESH_MUTATION = gql`
  mutation CHARTS_REFRESH_MUTATION($input: ChartsRefreshInput!) {
    chartsRefresh(input: $input) {
      ok
    }
  }
`
